import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faInbox } from '@fortawesome/free-solid-svg-icons';

export default function EmptyState({
  icon = faInbox,
  title,
  subtitle,
  action,
}: {
  icon?: IconDefinition;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      <div className="w-14 h-14 rounded-lg bg-gray-50 border border-gray-100 flex items-center justify-center mb-4">
        <FontAwesomeIcon
          icon={icon}
          className="text-gray-400 text-2xl"
        />
      </div>

      <p className="text-[14px] font-bold text-gray-800">{title}</p>

      {subtitle && (
        <p className="text-[12px] text-gray-500 font-medium mt-1 max-w-xs">
          {subtitle}
        </p>
      )}

      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}